import { Cookie } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Button } from '@alerte-immo/ui'
import { getConsent, onOpenCookieConsent, setConsent, type ConsentStatus } from '@/lib/analytics'
import { env } from '@/lib/env'

export function CookieConsent() {
  const [visible, setVisible] = useState(() => getConsent() === null)
  useEffect(() => onOpenCookieConsent(() => setVisible(true)), [])

  // La bottom nav mobile (AppLayout, h-14 + safe-area) n'existe que sur /app et
  // /admin : on remonte le bouton/bannière au-dessus d'elle pour ne pas la
  // chevaucher. Desktop (pas de nav) et pages d'auth gardent bottom-4.
  const { pathname } = useLocation()
  const overBottomNav = pathname.startsWith('/app') || pathname.startsWith('/admin')
  const bottomPos = overBottomNav
    ? 'bottom-[calc(4.5rem_+_env(safe-area-inset-bottom))] md:bottom-4'
    : 'bottom-4'

  // Bannière fermée → bouton flottant permanent pour rouvrir le choix (RGPD :
  // retirer son consentement doit être aussi simple que de le donner).
  if (!visible) {
    return (
      <button
        type="button"
        aria-label="Gérer les cookies"
        title="Gérer les cookies"
        onClick={() => setVisible(true)}
        className={`fixed ${bottomPos} left-4 z-30 h-9 w-9 inline-flex items-center justify-center rounded-full border border-border bg-background text-muted shadow-md hover:text-foreground transition-colors`}
      >
        <Cookie className="h-4 w-4" />
      </button>
    )
  }

  const choose = (status: ConsentStatus) => {
    setConsent(status)
    setVisible(false)
  }

  return (
    <div
      role="dialog"
      aria-label="Consentement cookies"
      className={`fixed ${bottomPos} left-4 right-4 sm:right-auto sm:max-w-md z-50 rounded-lg border border-border bg-background p-4 shadow-lg`}
    >
      <p className="text-sm text-muted">
        Avec votre accord, nous utilisons des cookies de mesure d’audience et un
        assistant conversationnel pour améliorer alerte-immo. Pas de publicité,
        pas de revente de données.{' '}
        <a
          href={`${env.landingUrl}/politique-de-confidentialite`}
          target="_blank"
          rel="noreferrer"
          className="underline underline-offset-2"
        >
          En savoir plus
        </a>
        .
      </p>
      <div className="mt-3 flex gap-2 justify-end">
        <Button variant="ghost" size="sm" onClick={() => choose('refused')}>
          Refuser
        </Button>
        <Button size="sm" onClick={() => choose('accepted')}>
          Accepter
        </Button>
      </div>
    </div>
  )
}
